export enum ACCOUNTS_LOCAL_STORAGE_KEYS {
  accountState = 'accountState',
}

export enum COMMON_LOCAL_STORAGE_KEYS {
  betaMode = 'betaMode',
  learningMode = 'learningMode',
}

export enum REFERRAL_CODE_LOCAL_STORAGE_KEYS {
  referralCode = 'referralCode',
}

export enum SIGNUP_POPUP_LOCAL_STORAGE_KEYS {
  viewedOfferings = 'viewedOfferings',
}
